export default __webpack_public_path__ + "static/media/pin.e87240de.png";